module.exports = __webpack_public_path__ + "img/stars-filled.0b97617f.svg";